import { useI18n } from '../i18n/useI18n';
import type { ClientInfo } from '../types';
import { getSafeAvatarUrl } from '../utils/validation';

interface Props {
  isOpen: boolean;
  singers: ClientInfo[];
  onClose: () => void;
  onInvite: (inviteeId: string, inviteeName: string) => void;
}

export default function DuetInviteModal({ isOpen, singers, onClose, onInvite }: Props) {
  const { t } = useI18n();
  if (!isOpen) return null;

  // Defensive dedupe: the gateway already dedupes by userId, but never render
  // two rows for the same person if a stale singers_list slips through.
  const uniqueSingers = singers.filter(
    (singer, idx) => singers.findIndex((s) => s.userId === singer.userId) === idx
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card duet-invite-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="modal-title">{t('duet.inviteTitle')}</h3>
          <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
            ✕
          </button>
        </div>
        <div className="modal-body">
          {uniqueSingers.length === 0 ? (
            <p className="duet-empty">{t('duet.noSingers')}</p>
          ) : (
            <ul className="duet-singer-list">
              {uniqueSingers.map((singer) => (
                <li key={singer.userId} className="duet-singer-row">
                  <img
                    src={getSafeAvatarUrl(singer.avatarUrl, singer.userName)}
                    alt=""
                    className="duet-singer-avatar"
                  />
                  <span className="duet-singer-name">{singer.userName}</span>
                  <button
                    className="btn-primary duet-invite-btn"
                    onClick={() => {
                      onInvite(singer.userId, singer.userName);
                      onClose();
                    }}
                  >
                    {t('duet.invite')}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
